import {
  IconCircleCheck,
  IconCircleX,
  IconCircleMinus,
} from '@tabler/icons-react';
import { ConsentStatus } from '@/types/consent.types';

interface ConsentStatusIndicatorProps {
  status: ConsentStatus;
  size?: number;
}

const STATUS_CONFIG = {
  permit: {
    icon: IconCircleCheck,
    color: 'green',
  },
  'not-answered': {
    icon: IconCircleMinus,
    color: 'gray',
  },
  deny: {
    icon: IconCircleX,
    color: 'red',
  },
} as const;

export function ConsentStatusIndicator({
  status,
  size = 20,
}: ConsentStatusIndicatorProps) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG['not-answered'];
  const Icon = config.icon;

  return (
    <Icon size={size} color={config.color} style={{ cursor: 'default' }} />
  );
}
